const Theme = {
  body_background_color: '#37464F',
  title_font: 'Lato',
  text_font: 'Lato',
  logo_image_url: 'wristcoin.png',
  token_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 2,
  button_color: '#009688',
  button_hover_text_color: '#009688',
  button_radius: 10,
  button_outlined_border_color: '#009688',
  button_outlined_hover_border_color: '#009688'
}

export default Theme
